import { api } from '@/shared/lib/api'
import type { User, UserCreateFormData, UserEditFormData, UserFilters } from '../types'

interface UserPaginatedResponse {
  data: User[]
  total_items: number
  current_page: number
  total_pages: number
  current_items_count: number
}

export const userService = {
  getAll: async (filters: UserFilters): Promise<UserPaginatedResponse> => {
    const { data } = await api.get('/users/', {
      params: { limit: filters.limit, skipe: filters.page },
    })
    return data
  },

  getById: async (id: number): Promise<User> => {
    const { data } = await api.get(`/users/${id}`)
    return data
  },

  search: async (param: string, value: string, exactMatch = false): Promise<User[]> => {
    const { data } = await api.get('/users_by_param/', {
      params: { param, value, exact_match: exactMatch },
    })
    return data
  },

  create: async (user: UserCreateFormData): Promise<User> => {
    const payload = {
      ...user,
      role: 'User',
      id_company: Number(localStorage.getItem('id_company') ?? 1),
    }
    const { data } = await api.post('/users/', payload)
    return data
  },

  update: async (id: number, user: Partial<UserEditFormData>): Promise<User> => {
    // Only send fields that have values (backend expects partial update)
    const payload: Record<string, unknown> = {}
    if (user.name) payload.name = user.name
    if (user.last_name) payload.last_name = user.last_name
    if (user.rut) payload.rut = user.rut
    if (user.email) payload.email = user.email
    if (user.password) payload.password = user.password
    if (user.id_branch_office) payload.id_branch_office = user.id_branch_office

    const { data } = await api.put(`/users/${id}`, payload)
    return data
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/users/${id}`)
  },
}
